export const formSteps = [
  "Basic Information",
  "Set Avatar Location",
  "Set Name Preference",
  "Preview & Publish",
];
export default function FormTabs({ activeStep }) {
  return (
    <nav className="mb-4 bg-white border border-greyBg shadow-lg pt-4 rounded-md">
      <ul className="flex items-center justify-between flex-col sm:flex-row">
        {formSteps.map((stepTitle, index) => (
          <li
            className={`px-2 border-b-4 text-center ${
              activeStep >= index ? "text-artfulRed border-artfulRed" : "text-gray-400 border-gray-300"
            } pb-2 w-full ${
              index === formSteps.length - 1
                ? "sm:text-right"
                : index === 0
                ? "sm:text-left"
                : "sm:text-center"
            } transition-all`}
            key={stepTitle}
          >
            <span className="w-full">{stepTitle}</span>
          </li>
        ))}
      </ul>
    </nav>
  );
}
